module.exports = __webpack_public_path__ + "img/phone-white.d16708e8.svg";